import 'twin.macro';
import React from 'react';
import { Bo } from '@teetsh/app/src/types/bo';
import { Menu } from '@teetsh/app/src/components/Menu';
import { Cycle, NiveauValue } from '@teetsh/app/src/containers/scholarSystem';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface Props {
  cycle: string;
  bo: Bo;
  onChange: (s: Cycle | NiveauValue) => void;
}

export function CycleSelector(props: Props) {
  const { bo, cycle, onChange } = props;
  return (
    <Menu>
      <Menu.Button
        className="group"
        tw="text-neutral-intense"
        small
        outlined
        rightIcon={ChevronDownIcon}
      >
        {cycle}
      </Menu.Button>

      <Menu.Items>
        {bo.cycles.map(c => (
          <Menu.Item
            key={c.nom}
            tw="whitespace-nowrap"
            onClick={() => {
              onChange(c.nom as Cycle | NiveauValue);
            }}
            text={c.nom}
          />
        ))}
      </Menu.Items>
    </Menu>
  );
}
